// src/data/quoteData-Coffee.js
export const quoteData = {
  meta: {
    title: "Website Design & Setup Quote",
    clientName: "Di",
    url: "https://coffeejourney.com.au",
    date: "08/08/2025",
    auditedBy: "2merative.com",
    quoteNumber: "Q3-2025-003",
    preparedBy: "Jason Toomer",
    summary: [
      "Hi Di — thanks for the opportunity to bring Coffee Journey to life online. This proposal delivers a highly visual, mobile-first website with an engaging homepage, story-driven About page, an SEO-ready Blog, and a retail experience built for growth.",
      "The build includes a managed online shop (30+ products), subscriptions (e.g., coffee plans) with a customer portal, and a streamlined checkout. We’ll focus on performance optimisation (image/lazy loading), and accessibility best practice for an inclusive, fast user experience.",
      "You’ll get ongoing reliability via backups and security updates, and we include 2 hours/month for product or content updates (additional time $100/hr). Hosting + SSL + 1 email are noted, and we’ll assist with DNS/deployment.",
      "You already own coffeejourney.com.au. We can pursue coffeejourney.com separately (up to your $4,000 budget) that purchase is outside this quote but fully supported by us.",
      "If anything needs tweaking, layout, copy, or features, I’m happy to adjust so this fits your brand and goals perfectly.",
      "On acceptance of this quote I will send an invoice for payment, terms detailed below.",
      "I look forward to working with you, Jason",
    ],
    },
  business: {
    name: "2merative",
    abn: "61775724636",
    email: "hello@2merative.com",
    phone: "0498 135 744",
  },

  options: [
    {
      label: "Custom Website Build for Coffee Journey",
      sections: {
        projectApproach: [
          "Highly visual, image-rich design with integrated information videos and interactive elements to grow time-on-page and conversions.",
          "Pages: Home, About, Blog, Products, and a fully managed Retail Cart, designed around clear user journeys and CTAs.",
          "Subscription capability (e.g., coffee plans) with customer portal, renewals, and pause/cancel controls to reduce churn.",
          "Fully mobile-responsive build with performance tuning (lazy loading, image optimisation) targeting strong Core Web Vitals.",
          "Advanced SEO setup: metadata templates, schema.org structured data (Products, BlogPosting), XML sitemap, robots rules, and clean URLs.",
          "Conversion-focused UX: trust badges, reviews/testimonials sections, clear pricing blocks, and streamlined checkout.",
          "Accessibility best practice aligned to WCAG 2.1 AA for inclusive browsing.",
          "Forms (subscription/contact) protected via reCAPTCHA or hCaptcha with server-side validation to minimise spam.",
          "Security & reliability: hardened config, backups, and update workflow for ongoing stability.",
          "Branding aligned to existing logo, colours, and style guide for a consistent brand experience.",
          "Customer will provide all product and branding images; we’ll optimise for speed and quality.",
          "Hosting + SSL + 1 email (via GoDaddy or Hostinger) noted; DNS and deployment support included.",
          "Includes 2 hours per month for product/content/blog updates (additional time at $100/hour).",
          "Scalable catalogue (30+ products) with categories, tags, and search/filter ready for growth.",
        ],
        oneOff: [
          { item: "Custom 5-page website build with blog, products, and subscriptions", cost: 6000 },
        ],
        recurring: [
          { item: "Hosting + SSL + 1 email", costMonthly: 20, costYearly: 240 },
          { item: "Includes up to 2 hours/month for updates", costMonthly: 0, costYearly: 0 },
          { item: "Domain registration (.com.au)", costYearly: 20 },
        ],
      },
    },
  ],

  gstRate: 0.1,

  notes: [
    "Customer owns coffeejourney.com.au and will provide GoDaddy login to move to 2merative hosting.",
    "Customer requests pursuit of coffeejourney.com with a budget up to $4,000 — to be managed outside of this quote.",
    "Customer will provide all imagery for the website unless otherwise arranged.",
    "Additional pages can be added on a per-page basis, cost depending on complexity.",
    "SSL ensures your website is secure and trusted by browsers.",
    "Advanced SEO setup includes optimized page titles, meta descriptions, and sitemaps.",
    "Transaction fees apply separately for eCommerce sales.",
    "Content updates or design changes beyond technical fixes billed at $100/hour.",
    "Hosting, SSL, and basic maintenance covered for first 12 months; recurring charges apply thereafter.",
  ],

  assumptionsExclusions: [
    "Customer's existing branding will be used unless otherwise specified.",
    "If new branding or logo design is required, quoted separately.",
    "All content provided by customer unless otherwise arranged.",
    "Client will provide product details (descriptions, prices, images) unless otherwise arranged.",
    "Advanced SEO campaigns or custom integrations outside the base scope.",
    "Shipping, tax, and refund policies must be provided by client.",
    "Client responsible for ongoing domain/hosting payments if using own GoDaddy account.",
    "Staging environments and additional revisions beyond two rounds may incur extra cost.",
  ],

  warrantySupport: [
    "30-day post-launch bug fix window (technical issues only) included.",
    "Basic support (security patches, uptime monitoring, plugin updates) for 3 months after launch.",
    "Future content updates or enhancements at $100/hour.",
    "Critical issues addressed within 1 business day; minor within 2–3 business days.",
  ],

  acceptance: {
    validUntil: "22/08/2025",
    paymentTerms: "50% deposit, 50% on launch (or milestone-based).",
  },
};
